import React, { useEffect, useState } from "react";
import { Modal, Alert, Spinner } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import pdfMake from "pdfmake/build/pdfmake.min.js";
import "pdfmake/build/vfs_fonts.js"; // подключаем шрифты
import "./ReportModal.css";

export default function ReportModal({ url, title, onClose }) {
    const [content, setContent] = useState("");
    const [error, setError] = useState(false);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (url) {
            setShow(true);
            setLoading(true);
            setContent("");
            setError(false);

            fetch(url)
                .then(res => {
                    if (!res.ok) throw new Error("Failed to load report");
                    return res.text();
                })
                .then(text => {
                    setContent(text);
                    setError(false);
                })
                .catch(err => {
                    setError(err.message);
                    setContent("");
                })
                .finally(() => setLoading(false));
        }
    }, [url]);

    const handleClose = () => {
        setShow(false);
        if (onClose) onClose();
    };

    const downloadPDF = () => {
        if (!content) return;

        const lines = content.split("\n").map(line => ({ text: line }));

        const docDefinition = {
            content: [
                { text: title || "Report", style: "header" },
                ...lines
            ],
            styles: {
                header: { fontSize: 18, bold: true, margin: [0, 0, 0, 10] },
            },
            defaultStyle: { fontSize: 12 }
        };

        pdfMake.createPdf(docDefinition).download(`${title || "report"}.pdf`);
    };

    const copyToClipboard = () => {
        const textToCopy = content || url;
        if (!textToCopy) return;

        navigator.clipboard.writeText(textToCopy).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const browserPrintPDF = () => {
        window.print();
    };

    if (!url) return null;

    return (
        <Modal show={show} onHide={handleClose} size="lg" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>

                <button
                    className="btn btn-sm btn-outline-secondary ms-2 mt-1"
                    onClick={copyToClipboard}
                >
                    {copied ? "Copied" : "Copy Report"}
                </button>
                <button
                    className="btn btn-sm btn-outline-secondary ms-2 mt-1"
                    onClick={browserPrintPDF}
                >
                    Print Report
                </button>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="d-flex align-items-center p-4">
                        <Spinner animation="grow" role="status" className="me-2">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        <span>Loading report...</span>
                    </div>
                ) : error ? (
                    <>
                        <Alert variant="danger">{error}</Alert>
                        <a href={url}>link</a>
                    </>
                ) : (
                    <div className="report-modal-content">
                        <ReactMarkdown
                            remarkPlugins={[remarkGfm]}
                            components={{
                                table: ({ node, ...props }) => (
                                    <table className="table table-bordered" {...props} />
                                ),
                                th: ({ node, ...props }) => (
                                    <th {...props} style={{ padding: "8px" }} />
                                ),
                                td: ({ node, ...props }) => (
                                    <td {...props} style={{ padding: "8px" }} />
                                ),
                            }}
                        >
                            {content}
                        </ReactMarkdown>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
}
